import React from "react";

import "./Footer.css";

export default function Footer() {
  return (
    <div className="Footer">
      <small>
        <a
          target="_blank"
          rel="noreferrer noopener"
          className="githubLink"
          href="https://github.com/SoleneBzght/dictionary-project"
        >
          Open-source code
        </a>{" "}
        by Sol ☀️
      </small>
    </div>
  );
}
